export default __webpack_public_path__ + "static/media/10.1616364e.svg";